<template>
    <!-- Parcelacija: the cadastre dropped it, but we still resolve the old re_key (support#1382). -->
    <i
        v-if="realEstate && realEstate.is_deleted"
        class="fa fa-exclamation-triangle text-danger m-l-5"
        v-tooltip="$t('real_estate:doesnt_exist_anymore:tooltip')"
        aria-hidden="true"
    ></i>
</template>

<script>
export default {
    name: "RealEstateDeletedIndicator",
    props: {
        realEstate: {
            type: Object,
            default: null
        }
    }
}
</script>
